import { handleKeyDown } from '../../utilities/utilities';

interface DropdownLinkProps {
  id: string;
  onClick: () => void;
  label: string;
}

const DropdownLink = ({ id, onClick, label }: DropdownLinkProps) => {
  return (
    <div
      id={id}
      role="button"
      className="mobile-dropdown-link"
      tabIndex={0}
      onKeyDown={(e) => handleKeyDown(e, onClick)}
      onClick={onClick}
    >
      {label}
      <i className="icon-sys icon-sys-navigation-chevron_right" />
    </div>
  );
};

export default DropdownLink;
